import { SubtitleStyles } from '../types';

/**
 * A helper function that returns the configuration object for the subtitle styles.
 * This is used in combination with the subtitle styles plugin for the VisualOn player.
 */
export const getSubtitleStyles = (): SubtitleStyles => {
  return {
    enable: true,
    previewSubtitleText: '',
    fontSize: {
      enable: true,
      value: '500%'
    }
  };
};

export default getSubtitleStyles;
